import { render, staticRenderFns } from "./meal.vue?vue&type=template&id=1f89a731&scoped=true"
import script from "./meal.vue?vue&type=script&lang=ts"
export * from "./meal.vue?vue&type=script&lang=ts"
import style0 from "./meal.vue?vue&type=style&index=0&id=1f89a731&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f89a731",
  null
  
)

export default component.exports